export const DATE_FORMAT = "YYYY-MM-DD";
export const DISPLAY_DATE_FORMAT = "DD-MMM-YYYY";

/** Penalty point above this value fails the inspection. */
export const FAIL_THRESHOLD = 20;

export const STYLE_PAGE_SIZE = 20;
export const STYLE_SEARCH_DEBOUNCE_MS = 300;
export const LIST_PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];
export const DEFAULT_LIST_PAGE_SIZE = 10;
